import {
  PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR,
  PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  RolodexPermissionsValues,
} from 'types'

export const PARTS_DATABASE_PERMISSIONS_LIST: RolodexPermissionsValues[] = [
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR,
  PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER,
]
